/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
// eslint-disable-next-line import/extensions
import axios from 'axios';
import * as actionTypes from './ActionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

// dispatch error message
export const dispatchErrorMessageData = (data) => ({
  type: actionTypes.HANDLE_ERROR_MSG_CA,
  payloadErr: data,
});
// dispatch pagination input value
export const dispatchInputValue = (data) => ({
  type: actionTypes.INPUT_FIELD_VALUE_ACTION,
  payloadInputVal: data,
});
// dispatch multiple pages data
export const dispatchMultipleSaveData = (data) => ({
  type: actionTypes.MULTIPLE_SAVE_DATA,
  savePayload: data,
});
// dispatch single page data
export const setContactAnomaliesTab = (data) => {
  return {
    type: actionTypes.CONTACT_ANOMALIES_TAB_DATA,
    contactAnomaliesObj: data,
  };
};
// dispatch tab value
export const dispatchTabValue = (data) => ({
  type: actionTypes.GET_TAB_VALUE,
  payload: data,
});
// dispatch contact anomalies (left grid)
export const dispatchContactAnomaliesCriteriaList = (data) => ({
  type: actionTypes.GET_SEARCH_CONTACT_ANOMALIES_BY_CRITERIA_LIST,
  searchContactAnomliesByCriteriaList: data,
});
// dispatch copy contact anomalies (right grid)
export const dispatchCopyContactAnomaliesCriteriaList = (data) => ({
  type: actionTypes.GET_SEARCH_COPY_CONTACT_ANOMALIES_BY_CRITERIA_LIST,
  searchCopyContactAnomliesByCriteriaList: data,
});
// dispatch contract table data
export const dispatchContractCriteriaList = (data) => ({
  type: actionTypes.GET_SEARCH_CONTRACT_BY_CRITERIA_LIST,
  searchContractByCriteriaList: data,
});
// dispatch manufacturer table data
export const dispatchMfgCriteriaList = (data) => ({
  type: actionTypes.GET_SEARCH_MFG_BY_CRITERIA_LIST,
  searchMfgByCriteriaList: data,
});
// dispatch need info message
export const dispatchNeedInfoMsg = (data) => ({
  type: actionTypes.GET_SEARCH_CODE_VALUE_LONG_DESC,
  searchNeedsAttCodeByCriteriaList: data,
});
// dispatch save contact tab data
export const dispatchSaveContact = (data) => ({
  type: actionTypes.SAVE_CONTACT,
  saveContactAnomalies: data,
});
// dispatch success message
export const handleSuccessMessages = (data) => ({
  type: actionTypes.HANDLE_SUCCESS_MESSAGE_FOR_CONTACT_ANOMALIES,
  successMessage: data,
});
// get contact anomalies API
export const getContactAnomaliesByCriteria = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_CONTACT_ANOMALIES_BY_CRITERIA_LIST, value)
    .then((response) => {
      return dispatch(
        dispatchContactAnomaliesCriteriaList(response.data && response.data)
      );
    })
    .catch(() => {
      dispatch(dispatchContactAnomaliesCriteriaList([]));
    });
};
// get copy contact anomalies API
export const getCopyContactAnomaliesByCriteria = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COPY_CONTACT_ANOMALIES_BY_CRITERIA_LIST, value)
    .then((response) => {
      return dispatch(
        dispatchCopyContactAnomaliesCriteriaList(response.data && response.data)
      );
    })
    .catch(() => {
      dispatch(dispatchCopyContactAnomaliesCriteriaList([]));
    });
};
// get contract info API
export const getContractInfo = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_CONTRACT_BY_CRITERIA_LIST, value)
    .then((response) => {
      return dispatch(
        dispatchContractCriteriaList(response.data && response.data)
      );
    })
    .catch(() => {
      dispatch(dispatchContractCriteriaList([]));
    });
};
// get manufacturer info API
export const getMfgInfo = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_MFG_BY_CRITERIA_LIST, value)
    .then((response) => {
      return dispatch(dispatchMfgCriteriaList(response.data && response.data));
    })
    .catch(() => {
      dispatch(dispatchMfgCriteriaList([]));
    });
};
// get need info API
export const getNeedInfoMsg = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_CODE_VALUE_LONG_DESC, value)
    .then((response) => {
      return dispatch(dispatchNeedInfoMsg(response.data && response.data));
    })
    .catch(() => {
      dispatch(dispatchNeedInfoMsg([]));
    });
};
// save contact anomalies API
export const saveContactMajor = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SAVE_CONTACT, value)
    .then((response) => {
      return dispatch(dispatchSaveContact(response.data && response.data));
    })
    .catch(() => {
      dispatch(dispatchSaveContact([]));
    });
};
// save contact anomalies API while closing the header menu tab
export const saveContactMajorClose = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SAVE_CONTACT, value)
    .then((response) => {
      return dispatch(dispatchSaveContact('close'));
    })
    .catch(() => {
      dispatch(dispatchSaveContact('close'));
    });
};
// clear contact anomalies screen data
export const clearReduxContactAnomaliesScreen = () => (dispatch) => {
  dispatch(dispatchContactAnomaliesCriteriaList([]));
  dispatch(dispatchCopyContactAnomaliesCriteriaList([]));
  dispatch(dispatchContractCriteriaList([]));
  dispatch(dispatchMfgCriteriaList([]));
  dispatch(dispatchNeedInfoMsg([]));
  dispatch(dispatchSaveContact([]));
};
